import TopicManagement from "@/modules/kodifikasi/components/TopicManagement";
import TopicManagementDetail from "@/modules/kodifikasi/components/TopicManagementDetail";
import TopicMapping from "@/modules/kodifikasi/components/TopicMapping";
import TopicMappingDetail from "@/modules/kodifikasi/components/TopicMappingDetail";

export default [
    {
        path: "/topic-management",
        name: "TopicManagement",
        component: TopicManagement,
    },
    {
        path: "/topic-management/detail",
        name: "TopicManagementDetail",
        component: TopicManagementDetail,
    },
    {
        path: "/topic-mapping",
        name: "TopicMapping",
        component: TopicMapping,
    },
    {
        path: "/topic-mapping/detail",
        name: "TopicMappingDetail",
        component: TopicMappingDetail,
    },
];



// WEBPACK FOOTER //
// ./src/modules/kodifikasi/router/kodifikasi.js